import { AcaCoreModule } from '@aca/core';
import { AcaFaIcon, AcaUiModule } from '@aca/ui';

import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';

@Component({
    selector: 'acadv-loading',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    @if (show()) {
      <div class="relative text-center flex flex-col" [acaTest]="[testIdPrefix(), 'Loading']">
        <div>
          <aca-icon [icon]="icons.spinnerThird" class="text-acaBlue text-4xl animate-spin-fast"></aca-icon>
        </div>
        <p class="text-dark-500">{{ message() }}</p>
      </div>
    }
    `,
    imports: [AcaCoreModule, AcaUiModule]
})
export class AcadvLoadingComponent {
  readonly show = input(true);
  readonly testIdPrefix = input('Loader');
  readonly message = input('One moment please...');

  icons = {
    spinnerThird: new AcaFaIcon(faSpinnerThird)
  };
}
